import React from 'react';
import AfComponentNavWhiteView from '../views/AfComponentNavWhiteView';

export const AfComponentNavWhiteController = () => <AfComponentNavWhiteView />;
